import React from 'react';
import { BrowserRouter, Switch, 
	Route, Redirect }    from 'react-router-dom';

import Login  from './pages/login/index';

import './fonts/BrandonGrotesque/style.css';
import './fonts/BrandonText/style.css';

import 'styles/parent.css';

export default function App () {
	return (
		<BrowserRouter>
			<Switch>
				<Route exact path='/auth/login'            component={Login} />
				<Redirect from='*' to='/auth/login' />
			</Switch>
		</BrowserRouter>
		);
}
